import React, { Component } from 'react';
import NotesModule from './NotesModule';
import WorkoutsModule from './WorkoutsModule';
import HabitsModule from './HabitsModule';
import WLogsModule from './WLogsModule';
import ToDosModule from './ToDosModule';
import TasksModule from './TasksModule';
import BudgetModule from './BudgetModule';
import { convertBoardTypeToClass, makeBEM } from '../global/utils';
import Icon from '../atoms/Icon';
import { BOARD_TYPES, UTILITY_CSS_CLASSES } from '../global/constants';
import { Fade, FadeInGrow, FadeOut } from './Animations';
import ReloadIcon from '../atoms/ReloadIcon';

const BOARD_MODULE_RELOAD_ANIMATION_DURATION = 500;

export default class BoardModule extends Component {
	// To:Do
	// 1. Here in the render, we should decide the module and pull the right one accordingly

	// 2. Don't render empty note

	constructor(props) {
		super(props);

		this.state = {
			boardID: this.props.boardID,
			type: this.props.type,
			title: this.props.title,
			color: this.props.color,
			data: this.props.data,
			focus: this.props.focus,
			switchViewAction: this.props.switchViewAction ? this.props.switchViewAction : false,
			controller: this.props.controller ? this.props.controller : false,
			reloading: false,
		};

		this.moduleName = 'board';

		this.bindFunctions();
	}
	
	bindFunctions() {
		this.refreshData = this.refreshData.bind(this);
	}

	componentDidMount() {
		// this.getModuleMarkup();
	}
	getModuleMarkup = (key) => {
		const reloading = this.state.reloading;
		var toReturn = <NotesModule 
							boardID={this.state.boardID}
							key={key}
							controller={this.state.data}
						/>
		switch(this.state.type) {
			case BOARD_TYPES.notes:
				toReturn = <NotesModule 
								boardID={this.state.boardID}
								key={key}
								controller={this.state.data}
								reloading={reloading}
			    			/>;
				break;
			case BOARD_TYPES.workouts:
				toReturn = <WorkoutsModule 
								boardID={this.state.boardID}
								key={key}
			    				contents={this.state.contents}
								controller={this.state.data}
								reloading={reloading}
			    			/>;
				break;
			case BOARD_TYPES.habits:
				toReturn = <HabitsModule
							parentID={this.state.boardID}
							controller={this.state.data}
							reloading={reloading}
						/>
				break;

			case BOARD_TYPES.wlogs:
				toReturn = <WLogsModule
							parentID={this.state.boardID}
							controller={this.state.data}
							reloading={reloading}
						/>
				break;

			case BOARD_TYPES.todo:
				toReturn = <ToDosModule
							boardID={this.state.boardID}
							data={this.state.data}
							controller={this.state.data}
							reloading={reloading}
						/>
				break;
			case BOARD_TYPES.tasks:
				toReturn = 
						<TasksModule
							boardID={this.state.boardID}
							key={key}
							controller={this.state.data}
							reloading={reloading}
						/>
				break;
			case BOARD_TYPES.budget:
				toReturn = <BudgetModule
							parentID={this.state.boardID}
							controller={this.state.data}
							reloading={reloading}
						/>
				break;


			default: 
				break;
		}
		return toReturn;
	}

	createNodeBoyMarkup = (body) => {
		return {__html: body}
	}

	test = (event) => {
		console.log("Pose complete");

		var treshold = 120;
		if ( event.y != undefined ) {
			if ( event.y >= treshold ) {
				console.log("Refresh");
			}
		} else {
			if ( event.changedTouches && event.changedTouches.length > 0 ) {
				if ( event.changedTouches[0].clientY > treshold ) {
					console.log("Refresh");
				}

			}
		}
		
	}

	refreshData() {
		const controller = this.state.controller;

		this.setState({
			reloading: true
		});

		if ( controller.reloadData ) {
		
			const fetchProgress = controller.reloadData();
			fetchProgress.then(() => {
				setTimeout(() => {
					this.setState({
						reloading: false,
					});
				}, BOARD_MODULE_RELOAD_ANIMATION_DURATION);
				
			});
		} 
	}

	render() {
		const type = convertBoardTypeToClass(this.state.type);
		const typeClass = `${this.moduleName}--${type}`

		const focusClass = this.props.focus ? 'focus' : '';
		const wrapperClass = `${this.moduleName} ${focusClass} ${typeClass}`;

		const switchViewAction = this.state.switchViewAction;
		const titleWrapperModifier = switchViewAction ? `${makeBEM(this.moduleName, 'title-wrapper')}--has-btn` : '';
		const titleWrapperClass = `${makeBEM(this.moduleName, 'title-wrapper')} ${titleWrapperModifier}`;
		const settingBtnClass = `btn btn--icon btn--no-border btn--setting rotate-icon-on-hover ${makeBEM(this.moduleName, 'setting-btn')}`;
		const reloadBtnClass = `btn btn--icon btn--no-border btn--setting rotate-icon-on-hover ${makeBEM(this.moduleName, 'reload-btn')} `;	

		return (			
		      <div className={ wrapperClass }>
				<div className={ titleWrapperClass } >
					{ 
						switchViewAction &&
						<button className={settingBtnClass} onClick={switchViewAction}>
							<Icon name="settings" size={3} />
						</button>
					}
					<h3 className={`h3 ${makeBEM(this.moduleName, 'title')}`}>
						{this.state.title}
					</h3>

					<button className={reloadBtnClass} onClick={this.refreshData}>
						<Icon name="restart" size={2} />
					</button>
				</div>
				
				<div className={ makeBEM(this.moduleName, 'contents-wrapper') }>
					{ 
						<Fade key={0} direction='in'>
							{ this.getModuleMarkup() }
						</Fade>
					}
				</div>
		      </div>
	    );
  	}
}